import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoneyBill, faCheck } from "@fortawesome/free-solid-svg-icons";

function ModalButton() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      {/* <Button variant="primary" onClick={handleShow}>
        Launch demo modal
      </Button> */}
      <Button className="btn-hover color-2" onClick={handleShow}>
        <FontAwesomeIcon icon={faMoneyBill}></FontAwesomeIcon> Submit
        Application
      </Button>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Application Submitted</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Once approved, your project will be shared with our network of buyers.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={handleClose}>
            <FontAwesomeIcon icon={faCheck}></FontAwesomeIcon> Got It
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalButton;
